module.exports = __webpack_public_path__ + "img/sup_cardsetting_ewalletid1.5e49440c.jpg";